function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: sticky;\n  float: right;\n  top: 20px;\n  z-index: 10;\n  display: flex;\n  justify-content: flex-end;\n  & > div {\n    display: inline-block;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 1rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: 50%;\n  top: 0;\n  right: 0;\n  position: absolute;\n  padding: 0;\n  border: 2px solid #ffffff;\n  transform: translate(50%, -50%);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import React from "react";
import styled from "styled-components";
import { flatMap, get as safeGet } from "lodash";
import { FiX } from "react-icons/fi";
import connectRequest from "../../../../utils/connect-request";
import { requests } from "../../../../modules/product";
import Card from "../../../card";
import Button from "../../../button";
import Textarea from "../../../textarea";
import { Col, Row } from "../../../grid";
var StickyCard = styled(Card)(_templateObject());
var CardSection = styled.div(_templateObject1());
var CloseButton = styled(Button)(_templateObject2());
var ANSWERS = [
    {
        label: "No",
        value: "no"
    },
    {
        label: "Yes",
        value: "yes"
    }, 
];
function _Feedback(param) {
    var product = param.product, submitFeedback = param.submitFeedback, className = param.className;
    var ref = _slicedToArray(React.useState(false), 2), submitted = ref[0], setSubmitted = ref[1];
    var ref1 = _slicedToArray(React.useState(null), 2), answer = ref1[0], setAnswer = ref1[1];
    var ref2 = _slicedToArray(React.useState(""), 2), comments = ref2[0], setComments = ref2[1];
    if (submitted) return null;
    var rows = product.rows;
    var feedbackRow = rows.find(function(r) {
        return r.rowType === "component:feedback";
    });
    if (!feedbackRow) return null;
    var question = safeGet(feedbackRow.control, "question") || "";
    var hint = safeGet(feedbackRow.control, "hint") || "";
    var onSubmit = function() {
        setSubmitted(true);
        submitFeedback({
            objectId: product.id,
            objectType: "product",
            objectName: product.name,
            question: question,
            response: answer === null || answer === void 0 ? void 0 : answer.value,
            comments: comments
        });
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(StickyCard, {
        zDepth: 1,
        className: className
    }, function() {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CardSection, null, !answer && flatMap(question.split("\n"), function(line, i) {
            return [
                /*#__PURE__*/ React.createElement("br", {
                    key: i
                }),
                line
            ];
        }).slice(1), /*#__PURE__*/ React.createElement(CloseButton, {
            onClick: function() {
                return setSubmitted(true);
            }
        }, /*#__PURE__*/ React.createElement(FiX, null)), answer && /*#__PURE__*/ React.createElement(Textarea, {
            value: comments,
            onChange: function(ev) {
                return setComments(ev.target.value);
            },
            placeholder: hint
        })), /*#__PURE__*/ React.createElement(CardSection, null, /*#__PURE__*/ React.createElement(Row, {
            end: "xs"
        }, /*#__PURE__*/ React.createElement(Col, null, answer && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Button, {
            small: true,
            onClick: function() {
                return setAnswer(null);
            }
        }, "Cancel"), "\xa0", /*#__PURE__*/ React.createElement(Button, {
            small: true,
            onClick: onSubmit
        }, "Submit")), !answer && flatMap(ANSWERS, function(ans, i) {
            return [
                "\xa0",
                /*#__PURE__*/ React.createElement(Button, {
                    key: i,
                    small: true,
                    onClick: function() {
                        return setAnswer(ans);
                    }
                }, ans.label), 
            ];
        }).slice(1)))));
    }), /*#__PURE__*/ React.createElement("div", {
        style: {
            clear: "both"
        }
    }));
}
var Feedback = Object.assign(connectRequest(function() {
    return {
        submitFeedback: function(data) {
            return requests.submitFeedback(data);
        }
    };
})(_Feedback), {
    StickyCard: StickyCard
});
export default Feedback;
